import { EPlatform } from '@cian/webview/shared';
import * as React from 'react';

import { ApplicationContext } from '../applicationContext';

export interface IUseWebViewResult {
  isWebView: boolean;
  platform: EPlatform | null;
}

export function useWebView() {
  const { config } = React.useContext(ApplicationContext);

  const result = React.useMemo<IUseWebViewResult>(
    () => ({
      isWebView: config.get<boolean>('web.isWebView') ?? false,
      platform: config.get<EPlatform | null>('web.platform') ?? null,
    }),
    [config],
  );

  return result;
}
